import multipleInputNumber from './multipleInputNumber.vue'
export default multipleInputNumber
